import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentTemplateUpdateFailedAction = {
	type: 'DOCUMENT_TEMPLATE_UPDATE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentTemplateUpdateFailedAction => ({
	type: 'DOCUMENT_TEMPLATE_UPDATE_FAILED',
	payload,
});
